import React from "react";
import { Input } from "@jdcfe/legao";
import './style.scss';


export default function CreateAppInput()  {
  return (
   <div className="create_app_input">
    <div className='input_item'>
  <span className="title">应用名称</span>
       <Input className="appName" placeholder="请输入应用名称" maxLength={10} hasClear />
       <span className="errMsg">请输入应用名称</span>
    </div>
    <div className="input_item">
       <span className="title">
          回调地址
         <i className="icon_address"></i>
         <div className="que_tips">
            <div className="que_tips_box">
               接收鉴权码的接口url <a className="go_detail" href='/doc/guide' target='_blank' rel="noopener noreferrer">了解详情</a>
               <div className="arrow"></div>
               <div className="holder"></div>
            </div>
            
         </div>
        </span>
       <Input className="authCallbackUrl" placeholder="请输入回调地址" hasClear />
       <span className="errMsg">请输入正确的回调地址</span>
    </div>
    <div className="input_item">
       <span className="title">开发者邮箱</span>
       <Input className="developerEmail" placeholder="请输入邮箱地址，用以接收系统通知" hasClear />
       <span className="errMsg">请输入正确的邮箱地址</span>
    </div>
    <div className="input_item">
       <span className="title">开发者手机</span>
       <Input className="developerPhone" placeholder="请输入11位手机号码" hasClear />
       <span className="errMsg">请输入11位手机号码</span>
    </div>
   </div>
  )
}